import Breadcrumbs from 'shell/components/shared/breadcrumb';
import FormRegion from 'system/geographic/components/region/form';
import { CommonConsulateCrumbs } from '../constants';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import { __MUNICIPALITY_API_URL__ } from 'shell/constants/environment';
import { useParams } from 'react-router-dom';
import { Region } from 'shell/models/region';
import { HttpResponse } from 'shell/models/http-response';
import { ReactElement, useMemo, useEffect, Fragment } from 'react';
import { RegionForm } from 'system/geographic/pages/region/list/types';

const RegionDetailPage = (): ReactElement => {
  const params = useParams();

  const {
    get: getRegion,
    data,
    error,
    loading,
  } = useHttpFetch<HttpResponse<Region>>(`${__MUNICIPALITY_API_URL__}/geo/regione/${params.id}`);

  useEffect(() => {
    getRegion();
  }, []);

  const initialValues: RegionForm = useMemo(() => {
    const consulatePayload = data?.payload;
    if (!consulatePayload || !!error) {
      // empty
      return {
        code: '',
        name: '',
      };
    }
    return {
      code: consulatePayload.key?.codice,
      name: consulatePayload.nome,
    };
  }, [data, error]);
  return (
    <Fragment>
      <Breadcrumbs items={[...CommonConsulateCrumbs, { name: 'Dettaglio regione' }]} />
      {!loading && !error ? (
        <FormRegion title="Dettaglio regione" disabled initialValues={initialValues} />
      ) : null}
    </Fragment>
  );
};

RegionDetailPage.displayName = 'Page detail region';

export default RegionDetailPage;
